"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getBase64ForImage;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _fetch = _interopRequireDefault(require("../fetch"));

function getBase64ForImage() {
  return _getBase64ForImage.apply(this, arguments);
}

function _getBase64ForImage() {
  _getBase64ForImage = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var res,
        contentType,
        buffer,
        _args = arguments;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _fetch["default"].apply(void 0, _args);

          case 2:
            res = _context.sent;
            contentType = res.headers.get('content-type');
            _context.next = 6;
            return res.buffer();

          case 6:
            buffer = _context.sent;
            return _context.abrupt("return", "data:".concat(contentType, ";base64,").concat(buffer.toString('base64')));

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getBase64ForImage.apply(this, arguments);
}
//# sourceMappingURL=getBase64ForImage.js.map